import { render, staticRenderFns } from "./icon-type-badge.vue?vue&type=template&id=0fc1c592&"
import script from "./icon-type-badge.vue?vue&type=script&lang=js&"
export * from "./icon-type-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports